// Temporary widget — remove this file and its imports after use.

const STYLES = `
  @keyframes qb-entrance {
    0%   { opacity: 0; transform: translateY(32px) scale(.94); }
    100% { opacity: 1; transform: translateY(0)    scale(1);   }
  }
  @keyframes qb-float {
    0%, 100% { transform: translateY(0px);  }
    50%       { transform: translateY(-7px); }
  }
  @keyframes qb-glow {
    0%, 100% {
      box-shadow: 0 8px 28px rgba(30,50,10,.30),
                  0 0 0 1.5px rgba(212,217,128,.5);
    }
    50% {
      box-shadow: 0 16px 44px rgba(30,50,10,.45),
                  0 0 0 3px  rgba(212,217,128,.9),
                  0 0 28px   rgba(212,217,128,.22);
    }
  }
  @keyframes qb-shimmer {
    0%   { background-position: 200% center; }
    100% { background-position: -200% center; }
  }
  @keyframes qb-dot {
    0%, 100% { box-shadow: 0 0 0 0   rgba(212,217,128,.8); }
    60%       { box-shadow: 0 0 0 7px rgba(212,217,128,0);  }
  }
  @keyframes qb-leaf-spin {
    0%   { transform: rotate(-8deg); }
    50%  { transform: rotate(8deg);  }
    100% { transform: rotate(-8deg); }
  }

  /* Wrapper handles the continuous float */
  .qb-wrap {
    position: fixed; bottom: 24px; right: 24px; z-index: 1500;
    animation: qb-float 4s ease-in-out infinite;
    animation-delay: .6s;
  }

  /* Card handles entrance + glow */
  .qb-widget {
    width: 210px;
    background: linear-gradient(150deg, #3a5c12 0%, #4B7518 55%, #3d6213 100%);
    border-radius: 16px;
    padding: 18px 18px 15px;
    font-family: 'Nunito', system-ui, sans-serif;
    animation:
      qb-entrance .55s cubic-bezier(.2,.7,.2,1) both,
      qb-glow     3s  1s ease-in-out infinite;
    overflow: hidden;
    position: relative;
  }

  /* Subtle diagonal shine overlay */
  .qb-widget::before {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(
      125deg,
      rgba(255,255,255,.07) 0%,
      rgba(255,255,255,.0)  50%,
      rgba(255,255,255,.05) 100%
    );
    border-radius: inherit;
    pointer-events: none;
  }

  /* Top decorative bar */
  .qb-widget::after {
    content: '';
    position: absolute; top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, #D4D980, #edf07e, #D4D980);
    border-radius: 16px 16px 0 0;
  }

  .qb-header {
    display: flex; align-items: center; gap: 8px; margin-bottom: 8px;
  }
  .qb-dot {
    width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
    background: #D4D980;
    animation: qb-dot 1.8s ease-out infinite;
  }
  .qb-title {
    font-size: 13px; font-weight: 900; color: #fff;
    margin: 0; line-height: 1.3; flex: 1;
  }
  .qb-leaf {
    color: #D4D980; flex-shrink: 0;
    animation: qb-leaf-spin 3s ease-in-out infinite;
    display: inline-block;
  }
  .qb-sub {
    font-size: 11.5px; color: rgba(255,255,255,.72);
    margin: 0 0 14px; line-height: 1.55;
  }
  .qb-btn {
    display: flex; align-items: center; justify-content: center; gap: 7px;
    width: 100%;
    background: linear-gradient(
      90deg,
      #c4ca60 0%, #D4D980 20%, #edf07e 50%, #D4D980 80%, #c4ca60 100%
    );
    background-size: 300% auto;
    color: #3a4400;
    padding: 9px 14px; border-radius: 10px; border: none;
    font-size: 12.5px; font-weight: 900; cursor: pointer;
    font-family: 'Nunito', system-ui, sans-serif;
    letter-spacing: .02em;
    animation: qb-shimmer 2.4s ease-in-out infinite;
    transition: transform .2s, box-shadow .2s;
    text-decoration: none; position: relative; z-index: 1;
  }
  .qb-btn:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 8px 22px rgba(212,217,128,.55);
    animation-play-state: paused;
  }

  @media (max-width: 480px) {
    .qb-wrap   { bottom: 16px; right: 16px; }
    .qb-widget { width: 185px; }
  }
`;

export default function QuestionnaireBanner() {
  return (
    <>
      <style>{STYLES}</style>
      <div className="qb-wrap">
        <div className="qb-widget" role="complementary" aria-label="Questionnaire">
          <div className="qb-header">
            <span className="qb-dot" aria-hidden="true" />
            <p className="qb-title">Your help in improving the DSS</p>
            <svg className="qb-leaf" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M17 8C8 10 5.9 16.17 3.82 19.82A1 1 0 0 0 5 21c0 0 2-1 4-1s4-1 6-4 5-5 5-8-3-3-3 0z"/>
            </svg>
          </div>
          <p className="qb-sub">Please remember to answer our short questionnaire.</p>
          <a
            className="qb-btn"
            href="https://forms.gle/32ixMXncRyTXkWyo6"
            target="_blank"
            rel="noreferrer"
          >
            Answer now
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
              <polyline points="15 3 21 3 21 9"/>
              <line x1="10" y1="14" x2="21" y2="3"/>
            </svg>
          </a>
        </div>
      </div>
    </>
  );
}
